export interface ErrorWithMessage {
  message?: string;
}
export interface DetailedErrorType {
  message: string;
  details: string[];
}

export class DetailedError extends Error {
  constructor(message: string, public details: string[]) {
    super(message);
    this.details = details;
  }
}
